import { ClipboardList, Factory, Gauge, TrendingUp } from "lucide-react";
import ApplicationPage, { type ApplicationPageConfig } from "@/components/ApplicationPage";

const config: ApplicationPageConfig = {
  key: "production",
  slug: "producao",
  icon: Factory,
  useCases: [
    { key: "standardization", icon: ClipboardList },
    { key: "monitoring", icon: Gauge },
    { key: "improvement", icon: TrendingUp },
    { key: "line", icon: Factory },
  ],
  benefits: ["oee", "downtime", "sops", "analytics"],
  formApplication: "Produção",
};

const Producao = () => <ApplicationPage config={config} />;

export default Producao;
